export default "__VITE_ASSET__99f05a22__"